<template>
<div class="main_wrap">
    <cafe-pdf ref="pdf" :show-nav="false" @on-success="pdfLoad" @on-scroll="pdfScroll" :filePath="pdfSrc">
        <template slot="footer">
            <i class="el-icon-zoom-in" @click="pdfZoomUp()"></i>
            <i class="el-icon-zoom-out" @click="pdfZoomDown()"></i>
            <button :disabled="pdfCurrentNum<=1" @click="pdfPre"> &lt; </button>
            <input disabled type="text" :min="1" :max="pdfPageNum" v-model.number="pdfCurrentNum" @change="pdfPageChange(pdfCurrentNum)">
            <button :disabled="pdfCurrentNum>=pdfPageNum" @click="pdfNext"> &gt; </button>
        </template>
    </cafe-pdf>
</div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
@Component({})
export default class PdfViewer extends Vue{
    pdfSrc = ''
    pdfPageNum = null
    pdfScale = 1
    pdfCurrentNum = 1

    mounted(){
        let uriUrl = ''
        if(this.$route.query.url){
            uriUrl = this.$route.query.url
        }
        console.log(uriUrl,'url')
        this.pdfSrc = decodeURIComponent(uriUrl)
        console.log(this.pdfSrc,'abcs')
    }

    pdfZoomUp(){
        this.pdfScale = this.pdfScale + 0.1
        this.$refs.pdf.changeScale(this.pdfScale)
    }
    pdfZoomDown(){
        this.pdfScale = this.pdfScale - 0.1
        this.$refs.pdf.changeScale(this.pdfScale)
    }

    pdfLoad(val) {
        this.pdfPageNum = val;
    }

    pdfScroll(val) {
        this.pdfCurrentNum = val;
    }

    pdfPageChange() {
        this.file = this.src;
    }

    pdfPre(){
        this.$refs.pdf.prePage();
    }
    pdfNext(){
        this.$refs.pdf.nextPage();
    }
    pdfFileChanged(val) {
        this.$refs.pdf.goToPage(val);
    }
    pdfPrint() {
        this.$refs.pdf.printFile();
    }
}
</script>
<style lang="less" scoped>
    .main_wrap{
        width: 100vw;
    }
    /deep/ .pdf-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        input{
            text-align: center;
        }
    }
</style>